import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  ActionType,
  CreateRequestedAction,
  DeleteRequestedAction,
  ListRequestedAction,
  ParametricStore,
  UpdateRequestedAction,
} from './types';
import {
  parametricStoresListSuccess,
  parametricStoresListFailure,
  parametricStoresCreateSuccess,
  parametricStoresCreateFailure,
  parametricStoresUpdateSuccess,
  parametricStoresUpdateFailure,
  parametricStoresDeleteSuccess,
  parametricStoresDeleteFailure,
} from './actionCreators';
import ParametricStoresApi from '../../services/ParametricStoresApi';
import { HttpRequestError } from '../../types';

function* listParametricStores({ country }: ListRequestedAction) {
  try {
    const { data }: AxiosResponse<ParametricStore[]> = yield call(
      ParametricStoresApi.list,
      country
    );
    yield put(parametricStoresListSuccess(data));
  } catch (error) {
    yield put(parametricStoresListFailure(error as HttpRequestError));
  }
}

function* createParametricStore({ payload }: CreateRequestedAction) {
  try {
    const { data }: AxiosResponse<ParametricStore> = yield call(
      ParametricStoresApi.create,
      payload
    );
    yield put(parametricStoresCreateSuccess(data));
  } catch (error) {
    yield put(parametricStoresCreateFailure({ ...(error as HttpRequestError), notified: true }));
  }
}

function* updateParametricStore({ country, code, payload }: UpdateRequestedAction) {
  try {
    yield call(ParametricStoresApi.update, code, country, payload);
    yield put(parametricStoresUpdateSuccess(country, code, payload));
  } catch (error) {
    yield put(parametricStoresUpdateFailure({ ...(error as HttpRequestError), notified: true }));
  }
}

function* deleteParametricStore({ country, code }: DeleteRequestedAction) {
  try {
    yield call(ParametricStoresApi.remove, code, country);
    yield put(parametricStoresDeleteSuccess(country, code));
  } catch (error) {
    yield put(parametricStoresDeleteFailure(error as HttpRequestError));
  }
}

export default [
  takeLatest(ActionType.listRequested, listParametricStores),
  takeLatest(ActionType.createRequested, createParametricStore),
  takeLatest(ActionType.updateRequested, updateParametricStore),
  takeLatest(ActionType.deleteRequested, deleteParametricStore),
];
